import { readResourceRaw } from "@pocketsign/in-app-sdk";
import { createFileRoute, redirect } from "@tanstack/react-router";
import {
  KESENNUMA_CAMPAIGN_END_DATE,
  KESENNUMA_CAMPAIGN_START_DATE,
  MIYAGI_BOUSAI_RESOURCE_ID,
  MIYAGI_BOUSAI_WELCOME_CAMPAIGN_END_DATE,
  MIYAGI_BOUSAI_WELCOME_CAMPAIGN_START_DATE,
  MIYAGI_RESIDENCE_CARD_CAMPAIGN_END_DATE,
  MIYAGI_RESIDENCE_CARD_CAMPAIGN_START_DATE,
  R7_MIYAGI_CAMPAIGN_END_DATE,
  R7_MIYAGI_CAMPAIGN_START_DATE,
  SHIROISHI_CAMPAIGN_END_DATE,
  SHIROISHI_CAMPAIGN_START_DATE,
} from "../../../config";
import { login } from "../../../libs/connect";
import { getCurrentTime } from "../../../libs/date";
import { AppError, ERROR_CODES } from "../../../libs/errors";
import { t } from "../../../libs/i18n";
import { sdk } from "../../../libs/sdk";

export const Route = createFileRoute("/_authed/lottery/bousai/callback")({
  loader: async ({ context: { tenant } }) => {
    const response = await readResourceRaw(sdk, {
      resourceId: MIYAGI_BOUSAI_RESOURCE_ID,
    });

    // 防災の登録が確認できない場合はエラー
    // 防災の登録が完了せずここに到達することはない
    if (response.result === "error") {
      throw new AppError(ERROR_CODES.BOUSAI_RESOURCE_READ_FAILED, undefined, {
        sdkErrorNo: response.errno,
      });
    }

    if (response.value === null || JSON.parse(response.value).length === 0) {
      throw new AppError(ERROR_CODES.BOUSAI_RESOURCE_READ_FAILED);
    }

    // 防災IDをバックエンドに登録するためログインし直す
    await login(tenant);

    const currentTime = await getCurrentTime();

    // localStorageから遷移元を取得
    const callbackSource = localStorage.getItem("bousai_callback_source");
    localStorage.removeItem("bousai_callback_source"); // 使用後削除

    // 白石市キャンペーンからの遷移
    if (callbackSource === "shiroishi") {
      if (
        currentTime.date >= SHIROISHI_CAMPAIGN_START_DATE &&
        currentTime.date <= SHIROISHI_CAMPAIGN_END_DATE
      ) {
        return redirect({
          to: "/lottery/grant/processing",
          search: { campaign: "r8AntiInflation" },
        });
      }
      return redirect({
        to: "/",
        state: {
          toast: {
            message: t("キャンペーン期間外です"),
            type: "error",
          },
        },
      });
    }

    // 気仙沼市キャンペーンからの遷移
    if (callbackSource === "kesennuma") {
      if (
        currentTime.date >= KESENNUMA_CAMPAIGN_START_DATE &&
        currentTime.date <= KESENNUMA_CAMPAIGN_END_DATE
      ) {
        return redirect({
          to: "/lottery/grant/processing",
          search: { campaign: "r8AntiInflation" },
        });
      }
      return redirect({
        to: "/",
        state: {
          toast: {
            message: t("キャンペーン期間外です"),
            type: "error",
          },
        },
      });
    }

    // 「みやぎ防災」ウェルカムポイントキャンペーンからの遷移
    if (callbackSource === "miyagi-bousai-welcome") {
      if (
        currentTime.date >= MIYAGI_BOUSAI_WELCOME_CAMPAIGN_START_DATE &&
        currentTime.date <= MIYAGI_BOUSAI_WELCOME_CAMPAIGN_END_DATE
      ) {
        return redirect({
          to: "/lottery/grant/processing",
          search: { campaign: "r8OnSignup" },
        });
      }
      return redirect({
        to: "/",
        state: {
          toast: {
            message: t("キャンペーン期間外です"),
            type: "error",
          },
        },
      });
    }

    // ようこそみやぎ外国人ポイントからの遷移
    if (callbackSource === "miyagi-residence-card") {
      if (
        currentTime.date >= MIYAGI_RESIDENCE_CARD_CAMPAIGN_START_DATE &&
        currentTime.date <= MIYAGI_RESIDENCE_CARD_CAMPAIGN_END_DATE
      ) {
        // 在留カード情報取得への同意とカード読み取りに進む
        return redirect({
          to: "/residence-card/apply",
        });
      }
      return redirect({
        to: "/",
        state: {
          toast: {
            message: t("キャンペーン期間外です"),
            type: "error",
          },
        },
      });
    }

    // R7みやぎキャンペーンからの遷移
    if (callbackSource === "miyagi") {
      if (
        currentTime.date >= R7_MIYAGI_CAMPAIGN_START_DATE &&
        currentTime.date <= R7_MIYAGI_CAMPAIGN_END_DATE
      ) {
        return redirect({
          to: "/lottery/grant/processing",
        });
      }
      return redirect({
        to: "/",
        state: {
          toast: {
            message: t("キャンペーン期間外です"),
            type: "error",
          },
        },
      });
    }

    // callbackSourceが取得できない場合は応募失敗
    return redirect({
      to: "/",
      state: {
        toast: {
          message: t(
            "キャンペーンの応募に失敗しました。もう一度お試しください。",
          ),
          type: "error",
        },
      },
    });
  },
});
